import Cookies from "js-cookie";

import { PREVIOUS_PATH_FOR_BR_EMPTY_VALUE } from "../../../../constants/bloomreach";
import { PREVIOUS_PATH } from "../../../../constants/local-storage";
import { EMPTY_ROUTE_HISTORY_MASK } from "../../../../context/router-history/constants";

export const getRefUrlFromCookie = () => {
  const previousPathsCookie = Cookies.get(PREVIOUS_PATH);
  if (!previousPathsCookie) {
    return PREVIOUS_PATH_FOR_BR_EMPTY_VALUE;
  }

  const previousPaths = previousPathsCookie.split(",");
  if (previousPaths[0] === EMPTY_ROUTE_HISTORY_MASK) {
    return PREVIOUS_PATH_FOR_BR_EMPTY_VALUE;
  }

  return previousPaths[0] ?? PREVIOUS_PATH_FOR_BR_EMPTY_VALUE;
};
